import { STORAGE_KEYS } from '../constants/constants.js';
import { accountStore } from '../store/AccountStore.js';

/**
 * 从 localStorage 中获取 tenantId
 * @param {string} storageKey - localStorage 的键名，默认为 STORAGE_KEYS.ERP_USER_INFO
 * @param {boolean} autoLogout - 是否在未找到用户信息时自动登出，默认为 true
 * @returns {string} tenantId，如果获取失败则返回 '0'
 */
export const getTenantIdFromStorage = (
  storageKey = STORAGE_KEYS.ERP_USER_INFO,
  autoLogout = true
) => {
  try {
    const userInfoStr = localStorage.getItem(storageKey);
    if (!userInfoStr) {
      console.warn(`未找到 localStorage 键: ${storageKey}`);
      if (autoLogout) {
        accountStore.logout('用户信息不存在，请重新登录');
      }
      return '0';
    }

    const userInfo = JSON.parse(userInfoStr);
    if (!userInfo || !userInfo.tenantId) {
      console.warn(`用户信息中未找到 tenantId，用户信息: ${userInfoStr}`);
      if (autoLogout) {
        accountStore.logout('用户信息不完整，请重新登录');
      }
      return '0';
    }

    return userInfo.tenantId;
  } catch (error) {
    console.error('从 localStorage 获取 tenantId 时发生错误:', error);
    if (autoLogout) {
      accountStore.logout('用户信息解析失败，请重新登录');
    }
    return '0';
  }
};
